import React, { FC } from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from 'theme/theme'

const WrappedThemeProvider: FC = ({ children }) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
)

export default WrappedThemeProvider
